<template>
    <div>
        <div style="display:none" class="back-step mb-4 mt-0" @click="backStep()">
			<img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('chat.return')}}
		</div>
        <div class="content-chat">
            <div class="contacts">
                <v-autocomplete :items="items" v-model="item" :min-len="0" :get-label="getLabel" :component-item='template' @update-items="updateItems" :auto-select-one-item="false">
                </v-autocomplete>
                <div class="container-scroll">
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in listContact" :key="index" @click="activePersonChat(index, item.id, item.groupId)" :ref="'divChat_'+item.id">
                            <span v-if="item.group.flagGroup && IsTeacher"  class="b-avatar border-0 rounded-circle" style="width: 54px; height: 54px;"><span class="b-avatar-img">
                                <img src='@/assets/img/group_user.png'></span>
                            </span>
                            <b-avatar v-else :src="item.urlPhoto" size="54px"></b-avatar>
                            <div class="list-item">
                                <div class="header-list-item">
                                    <h6 v-if="item.group.flagGroup && IsTeacher">{{$t('chat.group')}}: <span>{{item.group.code}}</span></h6>
                                    <h6 v-else class="bold">{{item.group.code}}</h6>
                                    <div class="status" v-show="!(item.group.flagGroup) || (!IsTeacher)"><div class="dot" :class="item.status ? 'on' : 'off'" /> {{item.status ? 'Online' : 'Offline'}}</div>
                                    <span class="last-hour">{{item.lastMessage ? item.lastMessage.strHourMessage : ""}}</span>
                                </div>
                                <p v-if="item.lastMessage && item.lastMessage.flagContent" style="color:#00B14F;font-weight:900;">
                                    {{item.group.flagGroup ? item.lastMessage.personTyping + " esta" : ""}} {{$t('chat.writing')}}...
                                </p>
                                <!-- <p v-else>
                                    <span v-if="item.lastMessage && item.group.flagGroup && item.lastMessage.personId != UserId" class="bold">{{item.lastMessage.strFullName}}: </span>
                                    {{item.lastMessage ? item.lastMessage.message : ""}}
                                </p> -->
                            </div>
                        </b-list-group-item>            
                    </b-list-group>
                </div>
            </div>
            <div class="posts">
                <div class="toast-msg" v-show="toastMsg"><span>{{$t('chat.loaging-message')}}...</span></div>
                <div class="posts-body-content" @scroll="loadMsgToScroll">
                    <div class="content-msg" v-for="(item, index) in messages" :key="index" :class="validMessage(item.personId == UserId)">
                        <b-avatar :src="item.photo" size="60px"></b-avatar>
                        <div class="message">
                            <h6 v-if="!validMessage(item.personId == UserId)">{{item.strFullName}}</h6>
                            <p>{{item.message}}</p>
                            <span><img class="svg" src="@/assets/icons/icon-time.svg">{{ FormatearHora(item.dateCreated)}}</span>
                        </div>
                    </div>
                </div>
                <div class="btn-bottom" :class="btnScrollBottom ? '' : 'd-none' " @click="bottomScroll()" :style="btnScrollBottom ? 'opacity: 1;' : 'opacity: 0;' "><img class="svg" src="@/assets/icons/icon-arrow-bottom.svg"></div>
                <div class="posts-footer-content" v-show="Boolean(idGroupChat)">
                    <div class="posts-footer-input">
                        <b-form-input v-model="textChatPerson" :disabled="IsMessagingEnabled(this.idGroup)" :placeholder="$t('chat.post-placeholder')" @keydown="TypingMessage" @keyup.enter="addTextChat()"></b-form-input>
                    </div>
                    <b-button variant="primary" @click="addTextChat()"><img class="svg" src="@/assets/icons/icon-send.svg">{{$t('chat.btn-send')}}</b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js'; 
import axios from "axios";
import * as tools from '@/assets/js/tools.js';
import ItemTemplate from "@/views/teacher/class/ItemTemplate ";
import { convertTimeToUserTimeFormat, getTimeZoneNameUser } from '@/assets/js/util.js';
 
let cancelToken

export default {
    data() {
      return {
        textChatPerson:'',
        listContact: [],
        messages: [],
        pageSize: 6,
        currentPage: 1,
        idGroupChat: 0,
        idGroup: 0,
        totalMsgs: 0,
        firstMsg: null,
        toastMsg: false,
        btnScrollBottom: false,
        items: [],
        item: null,
        template: ItemTemplate,
        filterGroupId: 0
      }
    },
    computed:{
        validFirstText(){
            return this.pruebaArrayTexto.texto=='' ? true : false
        },
        UserId: {
			get() {
				return this.$store.state.user_id;
			}
		},
		User: {
			get() {
				return this.$store.state.user;
			}
		},
        IsTeacher: {
            get(){
                return this.$store.state.is_teacher;
            }
        }
    },
    watch:{
        // messages: function(){
        //     console.log(this.currentPage)
        //     if(this.currentPage === 1 ) {
        //         this.bottomScroll();
        //     }
        // }
    },
    updated() {
		this.$nextTick(function () {
			tools.imgToSvg();
		})
        // if(this.currentPage === 1 ) {
        //     this.bottomScroll();
        // }
	},
    async created() {
        this.filterGroupId = parseInt(this.$route.params.filterGroupId);
        this.$pusher.connection.bind('error', function(err) {
            console.error(err);
        });
        await this.GetGroups();
        await this.InitPusher();
    },
    methods:{
        backStep(){
          this.$router.go(-1)
        },
        bottomScroll(){
            let element = document.querySelector(".posts-body-content");
            if(element.scrollHeight > element.clientHeight){
                element.scrollTo({ top: element.scrollHeight - element.clientHeight, behavior: 'smooth' })
                this.btnScrollBottom = false;
            }
        },
        InitPusher(){
            let _self = this;

            let channel = this.$pusher.subscribe('group_chat');
            channel.bind('typingMessage', function (data) {
                let index = _self.listContact.findIndex(x => x.id == data.GroupChatId);
                
                if(index > -1){
                    _self.listContact[index].lastMessage = {
                        flagContent: data.FlagContent,
                        personTyping: data.PersonTyping
                    };
                }
            });

            channel.bind('RefreshChat', function (data) {
                if(data && data.includes(_self.UserId)){
                    _self.GetGroups();
                }
            });

            // channel.bind('RefreshGroupMessage', function (data) {
            //     let index = _self.listContact.findIndex(x => x.id == data.GroupChatId);
            //     if(index){
            //         _self.GetGroups();
            //     }
            // });

            let presence_channel = this.$pusher.subscribe('presence-whatsup-members');
            presence_channel.bind('pusher:subscription_succeeded', function(members){
                //console.log("1: pusher:subscription_succeeded", members);
                Object.keys(members.members).map(function(currentMenber){
                    _self.RenderStatusUsers(currentMenber);
                });
            });

            presence_channel.bind('pusher:member_added', function(members){
                //console.log("2: pusher:member_added", members);
                _self.RenderStatusUsers(members.id);
            });

            presence_channel.bind('pusher:member_removed', function(members){
                //console.log("3: pusher:member_removed", members);
                _self.RenderStatusUsers(members.id, false);
            });

            Object.keys(presence_channel.members.members).map(function(currentMenber){
                _self.RenderStatusUsers(currentMenber);
            });
        },
        RenderStatusUsers(currentMenber, status = true){
            //console.log("RenderStatusUsers: " + currentMenber)
            let index = this.listContact.findIndex(x => x.group.id == currentMenber && (x.group.flagGroup == false || x.group.flagGroup == true && !this.isTeacher ) );
            if(index >= 0){
                this.listContact[index].status = status;
            }
        },
        getLabel (item) {
            this.item = item;
            this.activePersonChat(-1, item?.id, item?.groupId);
            return item?.name;
        },
        updateItems(text){
            let params = {
                idPerson: this.UserId,
                isTeacher: this.IsTeacher,
                filter: text
            };

            baseInstanceAxios
                .get(`${this.apiURL}/Chat/AutocompleteChat`, {params})
                .then(response => {
                    if (response.data != null && response.data.list) {
                        this.items = response.data.list.map(x => ({
                            id: x.id,
                            name: x.descripcion
                        }));
                    }
                });
        },
        async GetGroups(){
            let params = {
                idPerson: this.UserId,
                isTeacher: this.IsTeacher
            };

            await baseInstanceAxios
                    .get(`${this.apiURL}/Chat/GetContacts`, {params})
                    .then(response => {
                        if (response.data != null && response.data.list) {
                            this.listContact = response.data.list;
                        }
                    }).then(() => {
                        if(this.filterGroupId > 0){
                            let item = this.listContact.find(x=> x.groupId == this.filterGroupId);
                            if(item){
                                this.getLabel({name: item.group.code, id: item.id});
                            }
                            this.filterGroupId = 0;
                        }
                    });
        },
        validMessage(flag){
            return flag ? 'me' : '';
        },
        addTextChat(){
            if(this.textChatPerson){
                let newMessage = {
                    Message: this.textChatPerson,
                    FlagTeacher: this.IsTeacher,
                    PersonId: this.UserId,
                    GroupChatId: this.idGroupChat,
                    UserCreated: this.User.email,
                    socketId: this.$pusher.connection.socket_id
                };

                
                baseInstanceAxios
                    .post(`${this.apiURL}/Chat/SendMessage`, newMessage)
                    .then(response => {
                        if (response.data != null && response.data.return) {
                            this.GetConverstaion(true,null,null,false,true);
                        }
                    });
                this.textChatPerson = '';
            }
        },
        activePersonChat(valueNumber, value, idGroup){
            let a = document.querySelectorAll(".content-chat .list-group-item");
            if(valueNumber == -1 || !a[valueNumber].classList.contains("active")){
                a.forEach(b => b.classList.remove("active"));
                let element = this.$refs[`divChat_${value}`];
                if(element) element[0].classList.add("active");
                if(this.idGroupChat){
                    this.$pusher.unsubscribe('private-' + this.idGroupChat);
                }
                this.messages = [];
                this.idGroupChat = value;
                this.idGroup = idGroup;
                this.textChatPerson = '';
                this.currentPage = 1;
                this.GetConverstaion();

                let group_channel = this.$pusher.subscribe('private-' + value);
                let _self = this;
                group_channel.bind('new_message', function (data) {
                    if (_self.idGroupChat == data.message.GroupChatId) {
                        _self.GetConverstaion();
                    }
                });
            }
        },
        loadMsgToScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {
            let element = document.querySelector(".posts-body-content");
            var firstMsg = document.querySelector(".posts-body-content .content-msg")
            // var firstMsg = this.currentPage == 1 ? element.firstElementChild : element.children.item(this.pageSize);
            if(element.scrollTop == 0 && this.messages.length > 0) {
                
                var curOffset = firstMsg.offsetTop - element.scrollTop;
                this.toastMsg = true;
                this.currentPage ++;
                
                this.GetConverstaion(false,element,firstMsg,true,false)
                
                element.scrollTop =  curOffset;
            }
            if (!(scrollTop + clientHeight >= scrollHeight)) {
                this.btnScrollBottom = true;
            }else this.btnScrollBottom = false;
        },
        reOrder(val) {
            let arr = val.sort(function(a,b){
                return new Date(b.dateCreated) - new Date(a.dateCreated);
            });
            // arr = arr.reduce((unique, o) => {
            //     if(!unique.some(obj => obj === o)) {
            //     unique.push(o);
            //     }
            // })
            return arr.reverse()
        },
        GetConverstaion(lastMessage = false,elementMsg,firstMsg,validScrollTop,isClickMethod){
            let params = {
                idGroupChat: this.idGroupChat,
                Page: lastMessage ? 1 : this.currentPage,
                Size: this.pageSize,
            };

            baseInstanceAxios
                .get(`${this.apiURL}/Chat/GetConversation`, {params})
                .then(response => {
                    if (response.data != null && response.data.list) {

                        response.data.list.forEach(element => {
                            if(this.messages != 0) {
                                let isExist = this.messages.filter(item => item.dateCreated === element.dateCreated)
                                if(isExist.length == 0) {
                                    this.messages.push(element);
                                    if(validScrollTop){
                                        elementMsg.scrollTop =  firstMsg.offsetTop;
                                    }
                                }
                            } else {
                                this.messages = response.data.list;
                            }
                            // this.bottomScroll();
                            // this.messages.splice(0, 0, element)
                        });
                        // this.messages = this.messages.reverse()
                        this.messages = this.reOrder(this.messages)

                        //this.messages = response.data.list;
                        this.totalMsgs = response.data.rows;
                        this.toastMsg = false;
                        
                        if(this.messages.length > 0 && this.currentPage === 1) {
                            this.$nextTick(() => {
                                this.bottomScroll();
                            })
                            
                        }
                        if(isClickMethod){
                            setTimeout(()=> this.bottomScroll(),60)
                        }
                    }
                });
        },
        TypingMessage(){
            //Check if there are any previous pending requests
            if (typeof cancelToken != typeof undefined) {
                console.log("Operation canceled due to new request.")
                cancelToken.cancel("Operation canceled due to new request.")
            }

            //Save the cancel token for the current request
            cancelToken = axios.CancelToken.source()
            
            let params = {
                SocketId: this.$pusher.connection.socket_id,
                GroupChatId: this.idGroupChat,
                FlagContent: Boolean(this.textChatPerson),
            };
            params.PersonTyping = params.FlagContent ? this.User.strFullName : "";

            baseInstanceAxios
                .post(`${this.apiURL}/Chat/TypingMessage`, params,{ cancelToken: cancelToken.token })
                .then(response => {
                    if (response.data != null && response.data.list) {
                        this.messages = response.data.list;
                    }
                });
        },
        IsMessagingEnabled(idGroup){
            if(idGroup != 0){
               
                let item = this.listContact.find(x=> x.groupId == idGroup);
                if(item){
                    return !item.flagEnabled;
                }
                
            }
        },
        FormatearHora(dateMessage){
             
            let format_time = this.IsTeacher ? "MM/DD/YYYY h:mm a" : "DD/MM/YYYY h:mm a";  

            var tmpTime =this.$moment(dateMessage).format('YYYY-MM-DDTHH:mm:ss[Z]')
            var zone = getTimeZoneNameUser();
            //var time = convertTimeToUserTimeFormat(tmpTime,zone, this.$moment, "h:mm a");
            
            var time = convertTimeToUserTimeFormat(tmpTime, zone, this.$moment, format_time);
               
            return time;
        }
    }
  }
</script>